import { Selector, State } from "./types";
import { editMilestoneError } from "@planzone/dto";

function createSelector(getState: () => State): Selector {
  return {
    getMilestoneError({ uuid }) {
      const req = getState().find(({ milestone }) => milestone.uuid === uuid);

      return req ? req.error : editMilestoneError;
    },
    isMilestoneEditionRequestFailure({ uuid }) {
      const state = getState().find(({ milestone }) => milestone.uuid === uuid);

      return state ? state.request.isFailure : false;
    },
    isMilestoneEditionRequestPending({ uuid }) {
      const state = getState().find(({ milestone }) => milestone.uuid === uuid);

      return state ? state.request.isPending : false;
    },
    isMilestoneEditionRequestSuccess({ uuid }) {
      const state = getState().find(({ milestone }) => milestone.uuid === uuid);

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
